import { BaseError } from './common/BaseError';
/**
 * Use to signal about common errors which broke all generated app
 * This error means some problems with app which was generated by AppEngine.
 */
export class AppRuntimeError extends BaseError {
}
